import React from "react";
import { Shell, Reveal } from "../Components/Primitives";

const COLUMNS = [
  {
    title: "Navigate",
    links: [
      { label: "Index", href: "/" },
      { label: "Work", href: "/projects" },
      { label: "Resume", href: "/resume" },
    ],
  },
  {
    title: "Elsewhere",
    links: [
      { label: "GitHub", href: "https://github.com/Teemi2106", ext: true },
      {
        label: "LinkedIn",
        href: "https://www.linkedin.com/in/timi-gbenga-ba782b304",
        ext: true,
      },
      { label: "Twitter", href: "https://x.com/timmy_btw", ext: true },
    ],
  },
  {
    title: "Direct",
    links: [
      { label: "Email", href: "mailto:gbengatimi166@gmail.com" },
      { label: "Phone", href: "tel:+2347043464244" },
    ],
  },
];

const Footer = () => (
  <footer className="relative border-t border-rule pt-16 md:pt-24 pb-10">
    <Shell>
      <div className="grid gap-12 md:grid-cols-[1.4fr_repeat(3,_minmax(0,0.6fr))]">
        <Reveal>
          <p className="display display-sm max-w-sm">
            Built with restraint,
            <br />
            shipped with care.
          </p>
          <p className="label pt-6">Lagos, Nigeria &middot; WAT</p>
        </Reveal>

        {COLUMNS.map((col, i) => (
          <Reveal key={col.title} delay={100 + i * 70}>
            <p className="label pb-5">{col.title}</p>
            <ul className="space-y-3">
              {col.links.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    {...(l.ext
                      ? { target: "_blank", rel: "noopener noreferrer" }
                      : {})}
                    className="link-draw text-[14px] tracking-[-0.01em] text-ink-70 hover:text-ink transition-colors duration-500"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </Reveal>
        ))}
      </div>

      {/* The wordmark as architecture: set to the full measure,
          cropped at the baseline like a facade meeting the ground. */}
      <Reveal delay={220} className="pt-20 md:pt-28">
        <div className="overflow-hidden">
          <span
            className="block select-none whitespace-nowrap font-medium leading-[0.8] text-ink/[0.09]"
            style={{
              fontSize: "clamp(2.25rem, 12vw, 11rem)",
              letterSpacing: "-0.05em",
            }}
            aria-hidden="true"
          >
            TIMI GBENGA
          </span>
        </div>
      </Reveal>

      <div className="mt-8 flex flex-col gap-3 border-t border-rule pt-6 sm:flex-row sm:items-center sm:justify-between">
        <p className="label">
          &copy; {new Date().getFullYear()} Timi Gbenga
        </p>
        <p className="label">All rights reserved</p>
      </div>
    </Shell>
  </footer>
);

export default Footer;
